import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/**
 * Resolve a stored asset path/URL into something the browser can load.
 * - Relative paths from /api/admin/uploads (e.g. "/api/uploads/foo.jpg")
 *   are prefixed with the backend origin.
 * - Absolute URLs are returned untouched.
 */
export function assetUrl(value) {
    if (!value) return "";
    if (/^https?:\/\//i.test(value)) return value;
    if (value.startsWith("/")) return `${BACKEND_URL}${value}`;
    return value;
}

const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

export default api;
